"use client"

import { newSubscriptionFlowService } from "@/store/machine"
import { useActor } from "@xstate/react"
import { usePathname, useSearchParams } from "next/navigation"
import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"

export default function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()
  const [state] = useActor(newSubscriptionFlowService)
  const quoteId = state.context.quote?.meta?.quote_id

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`
      }
      posthog.capture("$pageview", {
        $current_url: url,
      })
    }
  }, [pathname, searchParams, posthog])

  useEffect(() => {
    if (quoteId && posthog) {
      posthog.setPersonProperties({
        quote_id: quoteId,
      })
    }
  }, [quoteId, posthog])

  return null
}
